import React from "react";
import styles from "./Blog.module.css";

const Blog = ({isInView}) => {
    return (
        <div className = {styles.page}>
            <h1 style = {{fontSize: "30px", marginLeft: "45vw", marginTop: "40vh", color: "white"}}>Blog</h1>
        </div>
    );
};

export default Blog;